console.log('custom.js')

document.addEventListener("scroll", function() {
  const stickyAtc = document.querySelector(".sticky-atc");
  if (!stickyAtc) return; // veiligheid, als element niet bestaat

  const scrollY = window.scrollY;
  const isMobile = window.innerWidth <= 768;
  const threshold = isMobile ? 500 : 300;

  if (scrollY >= threshold) {
    stickyAtc.classList.add("active");
  } else {
    stickyAtc.classList.remove("active");
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collapsible-tab__text.specs li').forEach(li => {
    const text = li.textContent;
    const parts = text.split(':');

    if (parts.length > 1) {
      const label = parts[0].trim(); 
      const value = parts.slice(1).join(':').trim();

      li.innerHTML = `${label}: <strong>${value}</strong>`;
    }
  });

  const moreBtn = document.querySelector('.collection-readmore-btn');
  if (!moreBtn) return;

  moreBtn.addEventListener('click', () => {
    document.querySelector('.collection-description--full').style.display = 'block';
    moreBtn.style.display = 'none';
  });
});